import React, { FunctionComponent, useEffect, useState, useMemo, useCallback } from "react"
import { debounce } from "lodash"
import { RequirementOptions } from "../api/models"
import { useUpdateCustomerBlockStatuses } from "../api/mutations"
import { UpdateBlockStatusesRequest } from "../api/models"
import { useCustomer } from "../../../common/contexts/CustomerContext"
import { useParams } from "react-router-dom"

interface RangeProps {
	requirementOptions: RequirementOptions[]
	categoryId: number
	requirementStatus: number
	blockId: number
}

const Range: FunctionComponent<RangeProps> = ({
	requirementOptions,
	categoryId,
	requirementStatus,
	blockId
}) => {
	const [rangeData, setRangeData] = useState([])
	const [sliderValue, setSliderValue] = useState(requirementStatus)

	const { mutate: updateCustomerBlock, isPending: updateCustomerBlockIsLoading } = useUpdateCustomerBlockStatuses()
	const { customer } = useCustomer()
	const {customerId} = useParams()

	useEffect(() => {
		setRangeData(requirementOptions)
	}, [requirementOptions])

	const STEPS = 1
	const MAX = 4
	const MIN = 1

	const handleUpdateCustomerBlock = (statusOption: number): void => {
		const submitUpdateBlock = () => {
			const request: UpdateBlockStatusesRequest = {
				CustomerId: customerId,
				Reason: "Reason",
				RequirementBlockId: blockId,
				statusOption
			}
			updateCustomerBlock(request, {
				onSettled: () => {
				}
			})
		}
		submitUpdateBlock()
	}

	const debouncedSlider = useMemo(
		() =>
			debounce(val => {
				handleUpdateCustomerBlock(val)
			}, 2000),
		[handleUpdateCustomerBlock]
	)

	const handleSlider = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
		setSliderValue(parseInt(e.target.value))
		debouncedSlider(parseInt(e.target.value))
	}, [])

	useEffect(() => {
		const elements = document.querySelectorAll('input[type="range"].slider-progress')
		elements.forEach((e: HTMLInputElement) => {
			e.style.setProperty("--value", e.value)
			e.style.setProperty("--min", e.min == "" ? "0" : e.min)
			e.style.setProperty("--max", e.max == "" ? "100" : e.max)
			e.addEventListener("input", () => e.style.setProperty("--value", e.value))
		})
	}, [sliderValue])

	return (
		<div className='range-container'>
			<div className='range-label-wrapper'>
				{rangeData.map(row => (
					<div className='range-label' key={row.id}>
						{row.label}
					</div>
				))}
			</div>
			<div className='range-input-wrapper'>
				<input
					type='range'
					min={MIN}
					value={sliderValue.toString()}
					max={MAX}
					step={STEPS}
					onChange={handleSlider}
					className={`range-input slider-progress range-input--cat${categoryId}`}
				/>
			</div>
		</div>
	)
}

export default Range
